import { IoChevronDown, IoChevronForward, IoHomeOutline } from "react-icons/io5";
import { HOME_SECTIONS } from "./navigationConfig";

export function NavItem({
  item,
  isCurrent,
  onClick,
  hasIcon = true,
  isSubItem = false,
  style = {},
}) {
  const Icon = item.icon;
  const className = `mobile-menu-item ${isCurrent ? "current" : ""} ${isSubItem ? "sub-item" : ""}`.trim();
  const content = (
    <>
      {hasIcon && Icon ? (
        <span className="mobile-menu-icon">
          <Icon />
        </span>
      ) : null}
      <span className="mobile-menu-label">{item.label}</span>
      {isCurrent ? <span className="mobile-menu-badge">You&apos;re here</span> : null}
    </>
  );
  const inlineStyle = { "--item-accent": item.accentColor || "var(--color-primary)", ...style };

  if (isCurrent) {
    return (
      <div className={className} style={inlineStyle}>
        {content}
      </div>
    );
  }

  return (
    <button className={className} onClick={onClick} style={inlineStyle}>
      {content}
    </button>
  );
}

export function ExpandableHomeItem({
  isExpanded,
  onToggle,
  onNavigateHome,
  onNavigateAnchor,
  isHomePage,
}) {
  if (isHomePage) return <HomeCurrentItem />;

  return (
    <div className="mobile-menu-expandable">
      <button className="mobile-menu-item expandable-header" onClick={onToggle}>
        <span className="mobile-menu-icon">
          <IoHomeOutline />
        </span>
        <span className="mobile-menu-label">Home</span>
        <span className="mobile-menu-chevron">
          {isExpanded ? <IoChevronDown /> : <IoChevronForward />}
        </span>
      </button>

      <div className={`mobile-menu-subitems ${isExpanded ? "expanded" : ""}`}>
        <div className="mobile-menu-subitems-inner">
          <button className="mobile-menu-item sub-item" onClick={onNavigateHome}>
            <span className="mobile-menu-label">Overview</span>
          </button>
          {HOME_SECTIONS.map((section) => (
            <button
              key={section.id}
              className="mobile-menu-item sub-item"
              onClick={() => onNavigateAnchor(section.anchor)}
            >
              <span className="mobile-menu-label">{section.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export function DirectHomeItem({ onClick, isHomePage }) {
  if (isHomePage) return <HomeCurrentItem />;

  return (
    <button className="mobile-menu-item" onClick={onClick}>
      <span className="mobile-menu-icon">
        <IoHomeOutline />
      </span>
      <span className="mobile-menu-label">Home</span>
    </button>
  );
}

function HomeCurrentItem() {
  return (
    <div className="mobile-menu-item current">
      <span className="mobile-menu-icon">
        <IoHomeOutline />
      </span>
      <span className="mobile-menu-label">Home</span>
      <span className="mobile-menu-badge">You&apos;re here</span>
    </div>
  );
}
